/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DueDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import CloseIcon from 'DesignSystem/Svgs/CloseIcon/index'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'



/** @type {import('Simple/types.js').View} */
export default function DueDate({
  children,
  viewPath = "/DesignSystem/TasksFilters/DueDate",
  setOuterRef,
  left,
  top,
  setInnerRef
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  setOuterRef,
  left,
  top,
  setInnerRef
  
})
let filtersDueDateValueData = fromData.useDataValue({ viewPath,
context: 'filters',
path: 'due_date',
})
let aggregateData = fromHelpers.getLabel(filtersDueDateValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let filtersDueDateValueData1 = fromData.useDataValue({ viewPath,
context: 'filters',
path: 'due_date',
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let filtersDueDateValueData2 = fromData.useDataValue({ viewPath,
context: 'filters',
path: 'due_date',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 innerRef={setOuterRef}
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 marginLeft={dtSpaceXxs}
 marginRight={dtSpaceXxs}
 color={dtColorsNeutral600}
 fontSize={11}
 lineHeight="13px"
 weight="medium"
 data="filters.due_date"
 aggregate="./helpers.js getLabel"
 text={aggregateData}
/>
<fromFlow.When is={!filtersDueDateValueData1}>
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 data="filters.due_date"
 fill2={dtColorsNeutral700}
 width={12}
/>
</fromFlow.When>
<fromFlow.When is={filtersDueDateValueData2}>
<CloseIcon
{...childProps}
  viewPath={`${viewPath}/CloseIcon`}
 data="filters.due_date"
 width="10px"
 height="10px"
/>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButton>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 left={left}
 top={top}
 innerRef={setInnerRef}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}